export interface Entidades {
    data: Datum[];
}

export interface Datum {
    type:       string;
    id:         string;
    attributes: Attributes;
    links:      Links;
}

export interface Attributes {
    codigo: string;
    nombre: string;
}

export interface Links {
    self: string;
}


export class Departamentos {
    id:              number;
    nombre:          string;
    activo:          number;
    id_zona:         number;
    zona_nombre:     string;
}

export class Municipios { 
    id:     string;
    nombre: string;
    activo: number;
}